import { Badge, Tooltip } from '../../../../../core'
import type { BadgeProps } from '../../../../../core'
import type { components } from '@joyful/openapi/types.gen'
import type { ComponentType, SVGProps } from 'react'
import { StethoscopeIcon, HospitalIcon } from 'lucide-react'
import type { EnumValueMeta } from '@joyful/utils'
import { createEnumSchema } from '@joyful/utils'

export interface EncounterBillingTypeBadgeProps extends Omit<
  BadgeProps,
  'children'
> {
  billingType: components['schemas']['BillingType']
}

interface BillingTypeMetadata extends EnumValueMeta {
  description: string
  icon: ComponentType<SVGProps<SVGSVGElement>>
}

export const BillingTypeSchema = createEnumSchema<
  components['schemas']['BillingType'],
  BillingTypeMetadata
>([
  {
    description: `Institutional claims are submitted on UB-04/CMS-1450 forms for facility based services.`,
    icon: HospitalIcon,
    title: 'Institutional',
    value: 'Institutional',
  },
  {
    description: `Professional claims are submitted on CMS-1500 forms for provider services.`,
    icon: StethoscopeIcon,
    title: 'Professional',
    value: 'Professional',
  },
])

export function EncounterBillingTypeBadge({
  billingType,
  ...props
}: EncounterBillingTypeBadgeProps) {
  const metadata = BillingTypeSchema.meta(billingType)
  const Icon = metadata.icon
  return (
    <Tooltip content={metadata.description}>
      <Badge
        variant="neutral"
        size="sm"
        startAdornment={<Icon className="size-3.5" />}
        {...props}
      >
        {metadata.title}
      </Badge>
    </Tooltip>
  )
}
